import React from 'react';
import { Box, Grid, Skeleton } from '@mui/material';

export const AddressSkeleton = () => {
  return (
    <Box sx={{ mt: 1 }}>
      <Grid container spacing={2} sx={{ mt: 1 }}>
        <Grid item xs={12} sm={6}>
          <Skeleton variant="rectangular" height={55} sx={{ borderRadius: 1 }} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Skeleton variant="rectangular" height={55} sx={{ borderRadius: 1 }} />
        </Grid>
      </Grid>

      <Grid container spacing={2} sx={{ mt: 1 }}>
        <Grid item xs={12} sm={6}>
          <Skeleton variant="rectangular" height={55} sx={{ borderRadius: 1 }} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Skeleton variant="rectangular" height={55} sx={{ borderRadius: 1 }} />
        </Grid>
      </Grid>

      <Grid container spacing={2} sx={{ mt: 1 }}>
        <Grid item xs={12} sm={6}>
          <Skeleton variant="rectangular" height={55} sx={{ borderRadius: 1 }} />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Skeleton variant="rectangular" height={55} sx={{ borderRadius: 1 }} />
        </Grid>
      </Grid>
    </Box>
  );
};
